import { render, staticRenderFns } from "./SanFenZhiYiGenZong.vue?vue&type=template&id=24feee8a&scoped=true&"
import script from "./SanFenZhiYiGenZong.vue?vue&type=script&lang=js&"
export * from "./SanFenZhiYiGenZong.vue?vue&type=script&lang=js&"
import style0 from "./SanFenZhiYiGenZong.vue?vue&type=style&index=0&id=24feee8a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24feee8a",
  null
  
)

export default component.exports